<template>
  <div class="user-avatar">{{ name[0] }}</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'UserAvatar',

  computed: {
    ...mapState('auth', {
      name: (state) => state.user.name,
    }),
  },
};
</script>

<style lang="scss" scoped>
.user-avatar {
  @apply bg-primary-500;
  @apply text-white;
  @apply font-bold;
  box-shadow: 0px 0px 12px 0px rgba(115, 102, 255, 0.35);
  padding: 0;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  border-radius: 10px;
  outline: none;
  width: 32px;
  height: 32px;
}
</style>
